import asyncComponent from '../../components/AsyncComponent';

const Partners = asyncComponent(() => import('../../containers/Partners/PartnerList'));

export default Partners;
